import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';

import SubNavigation from 'components/SubNavigation';
import SubNavigationItem from 'components/SubNavigation/SubNavigationItem';
import MagazineArticlesList from './MagazineArticlesList';
import MagazineArticleProfile from './MagazineArticleProfile';
import { normalizeMagazineQuery } from 'magazineQueries';
import './style.scss';

class Magazine extends Component {

  componentDidMount() {
    window.dispatchEvent(new Event('resize')); // The Flickity component wouldn't layout properly if this page is opened directly.
  }

  render() {
    const childrenType = this.props.children.type;
    const paginatedChildren = [MagazineArticlesList, MagazineArticleProfile];
    const className = classnames('Magazine', 'content-wrapper', {
      'has-pagination': paginatedChildren.indexOf(childrenType) >= 0
    });

    return (
      <section className={className}>
        <SubNavigation>
          <SubNavigationItem isForMagazine to="/magazine?sort=popular">{__('members.magazine.titles.popular')}</SubNavigationItem>
          <SubNavigationItem isForMagazine to="/magazine/contribute">{__('members.magazine.titles.contribute')}</SubNavigationItem>
          <SubNavigationItem isForMagazine to="/magazine?sort=recent" isActive={this.props.isNewActive}>{__('members.magazine.titles.new')}</SubNavigationItem>
          <SubNavigationItem isForMagazine to="/magazine?local=true">{__('members.magazine.titles.local')}</SubNavigationItem>
          <SubNavigationItem isForMagazine to="/magazine/categories">{__('members.magazine.titles.categories')}</SubNavigationItem>
          <SubNavigationItem isForMagazine to="/magazine?favourite=true">{__('members.magazine.titles.favourites')}</SubNavigationItem>
        </SubNavigation>

        {this.props.children}
      </section>
    );
  }
}

Magazine.propTypes = {
  children: PropTypes.element,
  isNewActive: PropTypes.bool
};

const mapStateToProps = (state, props) => {
  const { pathname, query } = props.location;
  const normalizedQuery = normalizeMagazineQuery(query);

  return {
    isNewActive: pathname === '/magazine' && normalizedQuery.sort === 'recent'
  };
};

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Magazine);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Magazine/index.js
 **/